import { graphql } from '@apollo/client/react/hoc';

import SuggestTag from 'buyside/graphql/mutations/SuggestTag';

import TagsFormSuggest from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/TagsForm/TagsFormSuggest/tagsFormSuggest';

const withSuggestTag = graphql(SuggestTag, {
  props: ({ mutate, ownProps: { employerProfileId } }) => ({
    suggestTag: ({ name, description }) => {
      return mutate({
        variables: { employerProfileId, name, description }
      });
    }
  })
});

const TagsFormSuggestContainer = withSuggestTag(TagsFormSuggest);

export default TagsFormSuggestContainer;
